export default "__VITE_ASSET__CzgNh0Wr__"